<template>
  <header class="bg-transparent relative z-30">
    <div
      class="w-full head bg-white flex justify-between items-center px-4 text-[#706F6F]"
    >
      <div
        class="absolute hidden sm:block w-full max-w-4xl h-48 left-1/2 -translate-x-1/2 -translate-y-1/2 top-48"
      >
        <img
          src="../assets/images/pepite2.png"
          class="w-6 absolute left-4 xl:-left-12 -bottom-16 rotate-[40deg]"
          style="align-items: center"
        />
        <img
          src="../assets/images/pepite1.png"
          class="w-14 absolute top-12 right-2 rotate-12"
          style="align-items: center"
        />
      </div>

      <div class="flex gap-4 items-center relative z-50">
        <router-link to="/"
          ><i class="fa-solid fa-house text-2xl md:text-3xl text-[#4D4D4C]"></i
        ></router-link>
      </div>
      <div class="relative z-50">
        <ul class="md:hidden">
          <li>
            <i
              @click="toggle"
              class="fa-solid text-3xl fa-bars cursor-pointer"
            ></i>
          </li>
        </ul>
        <ul class="text-lg space-x-6 hidden md:flex relative z-50">
          <li>
            <a
              href="https://oxoformdocs.fra1.digitaloceanspaces.com/696669f88644bf8a91004635/politique.pdf"
              target="_blank"
              class="uppercase"
              >Politique de confidentialité</a
            >
          </li>
          <li>
            <a
              href="https://oxoformdocs.fra1.digitaloceanspaces.com/696669f88644bf8a91004635/reglement.pdf"
              target="_blank"
              >RÈGLEMENT</a
            >
          </li>
          <li>
            <a
              href="https://oxoformdocs.fra1.digitaloceanspaces.com/696669f88644bf8a91004635/modalites.pdf"
              target="_blank"
              >MENTIONS LÉGALES</a
            >
          </li>
          <li><router-link to="/contact">CONTACT</router-link></li>
        </ul>
      </div>
    </div>
    <img
      v-if="
        currentRouteName != 'contact' &&
        currentRouteName != 'form' &&
        currentRouteName != 'later' &&
        currentRouteName != 'update' &&
        currentRouteName != 'missing' &&
        currentRouteName != 'update2'
      "
      src="../assets/images/nuage 1-min.png"
      class="w-[47vw] md:w-full md:max-w-[250px] lg:max-w-[320px] -mt-1 z-50 relative"
    />

    <div
      class="w-full text-center ombre relative"
      v-if="
        currentRouteName != 'finish' &&
        currentRouteName != 'update' &&
        currentRouteName != 'update2' &&
        currentRouteName != 'missing' &&
        currentRouteName != 'later' &&
        currentRouteName != 'form' &&
        currentRouteName != 'form2' &&
        currentRouteName != 'formtest' &&
        currentRouteName != 'mentions' &&
        currentRouteName != 'done' &&
        currentRouteName != 'contact'
      "
    >
      <img
        src="../assets/images/claim-min.png"
        class="md:w-full claim m-auto"
        alt=""
      />
      <img
        src="../assets/images/pepite1.png"
        class="sm:hidden w-[15vw] absolute top-0 right-[33vw] rotate-[20deg] z-50"
        style="align-items: center"
      />
    </div>
    <Teleport to="body">
      <Drawer @close="toggle" align="right" :closeable="true">
        <div v-if="open">
          <ul class="text-2xl text-[#6F1710] space-x-6">
            <li @click="toggle">
              <a
                class="uppercase"
                href="https://oxoformdocs.fra1.digitaloceanspaces.com/696669f88644bf8a91004635/politique.pdf"
                target="_blank"
                >Politique de confidentialité</a
              >
            </li>
            <li @click="toggle">
              <a
                href="https://oxoformdocs.fra1.digitaloceanspaces.com/696669f88644bf8a91004635/reglement.pdf"
                target="_blank"
                >RÈGLEMENT</a
              >
            </li>
            <li @click="toggle">
              <a
                href="https://oxoformdocs.fra1.digitaloceanspaces.com/696669f88644bf8a91004635/modalites.pdf"
                target="_blank"
                >MENTIONS LÉGALES</a
              >
            </li>
            <li @click="toggle">
              <router-link to="/contact">CONTACT</router-link>
            </li>
          </ul>
        </div>
      </Drawer>
    </Teleport>
  </header>
</template>

<script>
import Drawer from "vue-simple-drawer";
import Teleport from "vue2-teleport";
export default {
  name: "header-view",
  components: {
    Drawer,
    Teleport,
  },
  data() {
    return {
      open: false,
    };
  },
  methods: {
    toggle() {
      this.open = !this.open;
    },
  },
  computed: {
    currentRouteName() {
      return this.$route.name;
    },
    currentPath() {
      return this.$route.path;
    },
  },
};
</script>
